// La caja de prompt del Catálogo (ADR-2026-10-13-catalogo-con-el-agente): es `BarraEntradaChat`,
// la del Chat —voz con dictado, pegado y arrastre de archivos, planillas— y no la de Crear, que no
// tiene input de archivos. El texto y los adjuntos son de la pantalla (no del borrador compartido
// del chat): la portada los manda recién al crear la sesión. Lo demás (interruptores,
// preferencias, inteligencia) sale del contexto del chat, como en `CajaDelAgenteHome`.
import { useState } from 'react';
import { useChatAtlas } from '../../../../chat-atlas/ChatAtlasContext';
import { useAgentEnv } from '../../agentEnvContext';
import { BarraEntradaChat } from '../../../../chat-atlas/ui/BarraEntradaChat';
import { ModalDeFuentes } from '../../../../chat-atlas/ui/ModalDeFuentes';
import type { ChatAttachment } from '../../agentAttachments';

export interface CajaDeCatalogoProps {
  valor: string;
  onCambiarValor: (texto: string) => void;
  adjuntos: ChatAttachment[];
  onAgregarAdjunto: (a: ChatAttachment) => void;
  onQuitarAdjunto: (id: string) => void;
  onEnviar: (texto: string) => void;
  placeholder: string;
  /** Con esto, enviar no hace nada y se muestra el motivo. */
  bloqueado?: boolean;
  motivoBloqueo?: string;
  alto: 'normal' | 'amplio';
  /** Un contador: cada cambio pide el foco (la sugerencia que completa la caja). */
  pedidoDeFoco?: number;
  autoFoco?: boolean;
}

export const CajaDeCatalogo: React.FC<CajaDeCatalogoProps> = ({
  valor,
  onCambiarValor,
  adjuntos,
  onAgregarAdjunto,
  onQuitarAdjunto,
  onEnviar,
  placeholder,
  bloqueado = false,
  motivoBloqueo,
  alto,
  pedidoDeFoco,
  autoFoco = false,
}) => {
  const chat = useChatAtlas();
  const { companyId } = useAgentEnv();
  const [fuentes, setFuentes] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);

  const enviar = (texto: string) => {
    if (bloqueado) {
      setAviso(motivoBloqueo ?? 'Todavía no se puede enviar.');
      return;
    }
    setAviso(null);
    onEnviar(texto);
  };

  return (
    <div className="flex flex-col gap-2">
      <BarraEntradaChat
        valor={valor}
        onCambiarValor={(t) => {
          if (aviso) setAviso(null);
          onCambiarValor(t);
        }}
        onEnviar={enviar}
        streaming={false}
        onDetener={() => {}}
        cola={[]}
        onEncolar={() => false}
        onQuitarDeCola={() => {}}
        interruptores={chat.interruptores}
        onCambiarInterruptor={chat.setInterruptor}
        preferencias={chat.preferencias}
        onCambiarPreferencia={chat.setPreferencia}
        adjuntos={adjuntos}
        onAgregarAdjunto={onAgregarAdjunto}
        onQuitarAdjunto={onQuitarAdjunto}
        companyId={companyId ?? null}
        inteligencia={chat.inteligencia}
        onCambiarInteligencia={chat.setInteligencia}
        puedeSubirInteligencia={chat.puedeSubirInteligencia}
        modeloDeImagen={chat.modeloDeImagen}
        onCambiarModeloDeImagen={chat.setModeloDeImagen}
        autoFoco={autoFoco}
        placeholder={placeholder}
        alto={alto}
        variante="pantalla"
        pastillasDeContenido={false}
        onAbrirFuentes={() => setFuentes(true)}
        pedidoDeFoco={pedidoDeFoco}
      />
      {aviso && <p className="px-1 text-[13px] text-[#B42318]">{aviso}</p>}
      <ModalDeFuentes
        abierto={fuentes}
        onCerrar={() => setFuentes(false)}
        onAdjuntar={onAgregarAdjunto}
        multiple
        adjuntosActuales={adjuntos}
        onQuitar={onQuitarAdjunto}
        pestanaInicial="subidas"
      />
    </div>
  );
};
